import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import LearningFlow from './pages/LearningFlow';
import { useLearningBrand } from './hooks/useLearningBrand';
import { useLearningSession } from './hooks/useLearningSession';
import './learning.css';

function Learning(props) {
  const { match } = props;
  useLearningSession();
  useLearningBrand();

  return (
    <Switch>
      <Route exact path={`${match.url}/guidance`} component={LearningFlow} />
      <Route
        exact
        path={match.url}
        render={({ location }) => (
          <Redirect to={`${match.url}/guidance${location.search}`} />
        )}
      />
    </Switch>
  );
}

export default Learning;
